import { buildSearchUrlPath, durationToHoursAndMinutes } from 'wanderu-utils';

export const formatDuration = (timeInHours, i18nMoment, t) => {
    const time = i18nMoment.duration(timeInHours, 'hours');
    const duration = durationToHoursAndMinutes(time);
    const { minutes, hours, days } = duration;

    if (minutes && !hours && !days) {
        return `${minutes} min`;
    }

    if (!minutes && hours && !days) {
        return `${hours} hours`;
    }

    const string = `baseApp:trip-duration_${duration.days > 0
        ? 'days'
        : 'hours'}`;

    return t(string, duration);
};

export const getSearchUrls = ({ departDate, locationData }) => {
    const {
        placeId: destinationPlaceId,
        formattedAddress: formattedDestinationAddress,
    } = locationData.arrival;

    const {
        placeId: originPlaceId,
        formattedAddress: formattedOriginAddress,
    } = locationData.departure;

    const searchUrlRequest = {
        arrivePlace: formattedDestinationAddress,
        arrivePlaceId: destinationPlaceId,
        departDate,
        departPlace: formattedOriginAddress,
        departPlaceId: originPlaceId,
    };

    const trainUrl = buildSearchUrlPath(searchUrlRequest, { dm: 'train' });
    const busUrl = buildSearchUrlPath(searchUrlRequest, { dm: 'bus' });

    return {
        bus: busUrl,
        train: trainUrl,
    };
};
